// LoginForm.js
import React, { useState } from 'react';
import Logo from './Logo.js';
import './LoginForm.css';

function LoginForm({ handleLogin }) {
  const [username, setUsername] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(username);
    console.log('Submitted:', username);
  };


  const handleSetIp = (e) => {
    if (e.ctrlKey) {
      const newIp = prompt('Enter the new default IP:');
      if (newIp) {
        localStorage.setItem('zuta_defaultIP', newIp);
      }
    }
  };

  return (
    <div className="login-form-CTR">
      <Logo key="logo1"></Logo>
      <h2 onClick={handleSetIp} style={{ color: '#fff', marginBottom: '5vh', fontSize: "5vw" }}>Zutatool Calculator</h2>
      <form className="loginForm" onSubmit={handleSubmit}>
        <input
          className='largeInput'
          type="text"
          name="username"
          placeholder="Username"
          required
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <button type="submit">Login</button>
      </form>
    </div>
  );
}

export default LoginForm;